import Container from "../components/Container";
import { makeStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React from "react";

const getBackgroundColor = ({ backgroundColor, theme }) => {
    if (backgroundColor === "primary") {
        return theme.palette.primary.main;
    }
    return backgroundColor || "#fff";
};

const useStyles = makeStyles(theme => ({
    root(props) {
        const { backgroundColor, verticalPadding } = props;
        return {
            backgroundColor: getBackgroundColor({ ...props, theme }),
            paddingBottom: theme.spacing(verticalPadding || 0),
            paddingTop: theme.spacing(verticalPadding || 0),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        };
    }
}));

const PageTile = props => {
    const classes = useStyles(props);
    return (
        <div className={classes.root}>
            <Container>{props.children}</Container>
        </div>
    );
};

PageTile.propTypes = {
    backgroundColor: PropTypes.string,
    verticalPadding: PropTypes.number
};

export default PageTile;
